/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

/*
 * The runtime configuration the backend hands the Map Viewer.
 *
 * It arrives as the `#maps-config` JSON island the Flask app injects into
 * the shell, and is the whole contract between the two: endpoint URLs,
 * feature flags, map settings and interface strings. Boot parses it once
 * and sets it here; everything else reads it.
 *
 * Modules that need one value should prefer taking it as an option, so they
 * stay testable without a global. This is the fallback for the cases where
 * threading it through would mean an argument on every call.
 */

let current = {};

/**
 * Replace the configuration.
 *
 * @param {object} config - The parsed `#maps-config` payload.
 */
export function setConfig(config) {
    current = config || {};
}

/**
 * Read the configuration.
 *
 * @returns {object} The payload, or an empty object before boot has run.
 */
export function getConfig() {
    return current;
}
